export const SIZE = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}

export const VARIANT = {
  neutral: 'neutral',
  accent: 'accent',
  success: 'success',
  information: 'information',
  down: 'down',
  up: 'up',
  warning: 'warning',
  error: 'error',
  white: 'white',
  clear: 'clear'
}
